import React from 'react'
import { getString } from './utils'

export const Download = ({language}) => {
    return <div>{getString("thank", language)}<br/><br/>{getString("click", language)} <a href="https://www.getknowapp.com/download">KNOW</a> {getString("login", language)}<br/><br/><a href="https://www.getknowapp.com/download"> {getString("link", language)} </a></div>
}